import React, { useRef } from "react";

const VendorPartnerForm = () => {
  const formRef = useRef();

  const sendToWhatsApp = (e) => {
    e.preventDefault();

    const form = formRef.current;

    const message = `
🚗 *New Vendor Partnership Request*

👤 Vendor Name: ${form.vendor_name.value}
📧 Email: ${form.email.value}
🚘 Vehicle: ${form.vehicle.value}
📱 Mobile: ${form.mobile.value}
🏙 City: ${form.city.value}
📍 Address: ${form.address.value}
    `;

    const whatsappNumber = "919822136667"; // country code without +
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");
    form.reset();
  };

  return (
    <section style={{ padding: "80px 0", background: "#fff" }}>
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT CONTENT */}
          <div className="col-lg-6 mb-4">
            <h2 style={{ fontWeight: 700, fontSize: "38px" }}>
              Partner With Pune Corporate Cars <br />
              For Exclusive Benefits
            </h2>
            <p>Pune Corporate Car Rental Services</p>
            {/* <p>Pune Corporate Car Rental Services ™</p> */}
            <p>Premium Vehicles | Corporate Clients | Timely Payments</p>
          </div>

          {/* RIGHT FORM */}
          <div className="col-lg-6">
            <h6 style={{ color: "red", fontWeight: 600 }}>
              For Car Owners & Drivers
            </h6>
            <h3 style={{ fontWeight: 600 }}>Partner With Us</h3>

            <form ref={formRef} onSubmit={sendToWhatsApp}>
              <div className="row g-3 mt-3">

                <div className="col-md-6">
                  <input type="text" name="vendor_name" placeholder="Vendor Name *" className="form-control" required />
                </div>

                <div className="col-md-6">
                  <input type="email" name="email" placeholder="Email ID *" className="form-control" required />
                </div>

                <div className="col-md-6">
                  <input type="text" name="vehicle" placeholder="Vehicle You Have?" className="form-control" required />
                </div>

                <div className="col-md-6">
                  <input type="tel" name="mobile" placeholder="Mobile Number *" className="form-control" required />
                </div>

                <div className="col-md-6">
                  <input type="text" name="city" placeholder="City *" className="form-control" required />
                </div>

                <div className="col-md-6">
                  <input type="text" name="address" placeholder="Address *" className="form-control" required />
                </div>

                <div className="col-12 mt-3">
                  <button
                    type="submit"
                    style={{
                      background: "#FF0000",
                      color: "#fff",
                      border: "none",
                      padding: "12px 32px",
                      borderRadius: "6px",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    💬 Send on WhatsApp
                  </button>
                </div>

              </div>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
};

export default VendorPartnerForm;
